/**
 * Maintenance Mode Configuration
 * 
 * When MAINTENANCE_MODE is true:
 * - Only emails in ALLOWED_EMAILS can log in
 * - Users not in the allowed list will be automatically logged out
 * - A maintenance banner will be displayed on the login page
 */

export const MAINTENANCE_MODE = false;

export const ALLOWED_EMAILS = [
    'admin@snapfy.ai',
    'marcos@snapfy.ai',
];

export const MAINTENANCE_MESSAGE = 'Sistema em manutenção. Apenas administradores podem acessar no momento.';

/**
 * Check if an email is allowed to access the system during maintenance
 */
export const isEmailAllowed = (email: string): boolean => {
    if (!MAINTENANCE_MODE) return true;
    return ALLOWED_EMAILS.includes(email.toLowerCase());
};
